document.addEventListener('DOMContentLoaded', function () {
  var expanded = document.getElementById('wbExpanded');
  var circle   = document.getElementById('wbCircle');
  var mainVid  = document.getElementById('wbMainVideo');

  if (!expanded) return;

  expanded.style.display = 'block';
  if (circle) circle.style.display = 'none';

  if (mainVid) {
    mainVid.muted = true;
    mainVid.play().catch(function () {});
  }
});

// Expanded → Circle
function minimizeWatchBuy() {
  var expanded  = document.getElementById('wbExpanded');
  var circle    = document.getElementById('wbCircle');
  var mainVid   = document.getElementById('wbMainVideo');
  var circleVid = document.getElementById('wbCircleVideo');

  if (expanded) expanded.style.display = 'none';
  if (circle)   circle.style.display   = 'block';
  if (mainVid)  mainVid.pause();

  if (circleVid) {
    circleVid.muted = true;
    circleVid.play().catch(function () {});
  }
}

// Circle click → Expanded
function openWatchBuy() {
  var expanded  = document.getElementById('wbExpanded');
  var circle    = document.getElementById('wbCircle');
  var mainVid   = document.getElementById('wbMainVideo');
  var circleVid = document.getElementById('wbCircleVideo');

  if (circle)   circle.style.display   = 'none';
  if (expanded) expanded.style.display = 'block';
  if (circleVid) circleVid.pause();

  if (mainVid) {
    mainVid.muted = true;
    mainVid.currentTime = 0;
    mainVid.play().catch(function () {});
  }
}

// Circle ka X → poora widget band
function closeWatchBuyFull(event) {
  event.stopPropagation();
  var widget = document.getElementById('watch-buy-widget');
  if (widget) widget.style.display = 'none';
}